import styled from 'styled-components/macro'

export const StatsContainer = styled.div.attrs({
  'data-stats-container': 'true',
})`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const StatsCard = styled.div.attrs({
  'data-stats-card': 'true',
})`
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;

  min-width: 125px;

  /* Typography mirrors the homepage MetricCard: label text-sm (weight 400),
     value text-lg font-bold with leading-tight. */
  & h1 {
    margin: 0;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: #475467;
    white-space: nowrap;
  }

  & span {
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.25;
    color: #101828;
    font-variant-numeric: tabular-nums;
  }
`
